export default {"src":"/_next/static/media/Stroke Rehabilitation.1c2ba9e3.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};